import { CheckSquare } from "react-feather";
import { useCallback } from "react";
import { trackEvent } from "../../analytics/analyticsHandlers";
import { SearchQuerySetter } from "../../search/SearchQuery";
import { updateSearchQuery } from "../../search/useSearchQuery";
import { NavButton } from "./NavButton";

export const TodoButton = ({ disabled = false, size = 20 }: { disabled?: boolean; size?: number }) => {
  const setSearchFromSidebar: SearchQuerySetter = useCallback((state) => {
    updateSearchQuery(state);
    trackEvent("search_from_sidebar");
  }, []);

  const onClick = useCallback(() => {
    // Don't use onMouseDown for this because it leads to the following
    // error when pressed white the focus is in the search bar:
    //
    // Uncaught TypeError: Cannot read properties of null (reading
    // 'domFromPos') at coordsAtPos (index.js:459:32) at
    // EditorView.coordsAtPos (index.js:5306:1)
    //
    // There's a deeper problem here of the editor being in this null state
    // while features expect it exists, but for now this is a quick fix.
    setSearchFromSidebar({
      hasIncomplete: true,
    });
  }, [setSearchFromSidebar]);
  return (
    <NavButton
      id="todo-button"
      role="tooltip"
      data-microtip-position="right"
      aria-label={`All Incomplete Todos`}
      onClick={onClick}
      disabled={disabled}
    >
      <CheckSquare size={size} />
    </NavButton>
  );
};
